export const PROJECT_SEARCH_RESET_EVENT = 'projectSearchResetRequested';
export const PROJECT_SEARCH_SET_TERM_EVENT = 'projectSearchSetTermRequested';

type ProjectSearchScrollSource = 'browser-pop' | 'search-tab-click' | 'search-result-navigation';
type ProjectSearchScrollIntent = 'restore' | 'reset';

export function getProjectSearchPath(sessionId: string): string {
  return `/project/${sessionId}/search`;
}

export function getProjectSearchScrollStorageKey(sessionId: string): string {
  return `project-search-scroll:${sessionId}`;
}

export function getProjectSearchScrollIntentStorageKey(sessionId: string): string {
  return `project-search-scroll-intent:${sessionId}`;
}

export function getProjectSearchScrollIntent({
  sessionId,
  pathname,
  source,
}: {
  sessionId?: string | null;
  pathname: string;
  source: ProjectSearchScrollSource;
}): ProjectSearchScrollIntent | null {
  if (!sessionId) {
    return null;
  }

  if (source === 'search-tab-click') {
    return 'reset';
  }

  if (source === 'search-result-navigation') {
    return 'restore';
  }

  return pathname === getProjectSearchPath(sessionId) ? 'restore' : null;
}
